import _ from 'lodash'
import selects from 'scoreboard/components/selects'
import mapEscape from 'scoreboard/components/map-escape-field'

// Scaffolding of rich select that handle id selection in reports
export default function(select, rawData, selectedIdMap, opts) {
	var options = opts || {}

	var isSelected = options.findSelected || function(d) {
		d.selected = _.has(selectedIdMap, d.id)
		return d
	}

	var data = rawData.map(mapEscape('label'))
					  .map(function(d) {
					  	return isSelected(d, selectedIdMap)
					  })

	selects.filtering(select, _.defaults({
		accessors: {
			value: 'id',
			label: 'label'
		},
		options: data
	}, options))
}
